@if (location$ | async) {
  <agr-page-toolbar
    [stickyToolbar]="true"
    [stickyDetails]="true"
    [pageTitle]="
      location
        ? ('fertilisers-overview.title' | translate) +
          ' ' +
          location.name +
          ', ' +
          location.street +
          (location.houseNumber ? ' ' + location.houseNumber : '') +
          ', ' +
          location.city
        : ''
    "
    [isEmpty]="!location"
    [emptyTitle]="
      !!location ? (areAnyCropFieldsLinked === true ? ('orderTexts.noRequisite' | translate) : ('linkCropFields' | translate)) : ('selectLocation' | translate)
    "
    [emptyDescription]="
      !!location
        ? areAnyCropFieldsLinked === true
          ? ('orderTexts.noRequisiteDescription' | translate)
          : ('noLinkedCropFields' | translate)
        : ('noLocationSelected' | translate)
    "
    [showEmptyAction]="true"
    [emptyActionText]="
      !!location ? (areAnyCropFieldsLinked === true ? ('fieldAdvice' | translate) : ('linkCropFields' | translate)) : ('selectLocation' | translate)
    "
    emptyActionIcon="navigate_next"
    emptyActionColor="accent"
    (emptyAction)="doEmptyAction()"
    [hasPrimaryAction]="!!location"
    [isPrimaryActionDisabled]="isPrimaryActionDisabled"
    primaryActionIcon="shopping_cart"
    [primaryActionText]="'cartTexts.toOrder' | translate"
    (primaryAction)="confirmOrder()"
    [hasSecondaryAction]="!!location"
    secondaryActionIcon="receipt_long"
    [secondaryActionText]="'createFertilizerOrderReceipt' | translate"
    (secondaryAction)="createOrderReceiptReport()"
    [buttonItems]="buttonItems"
    (buttonAction)="buttonAction($event)"
  >
    <div class="layout--margin-top wrapper--spacing-horizontal content-wrapper">
      <div displayAlways>
        <agr-filter [config]="filterConfig"></agr-filter>
        @if (areAnyCropFieldsNotLinked === true) {
          <div class="notification notification-warning" data-test="overview-spray-license-warning">
            <mat-icon>warning</mat-icon>
            {{ 'notLinkedCropFields' | translate }}
          </div>
        }
      </div>

      @if ((fertiliserOrderplan$ | async)?.length) {
        <div class="orderable-products-container">
          <h3>{{ 'fertilisers-overview.table.orderableProductsTitle' | translate }}</h3>
          <app-overview-table
            (togglePrimaryActionTableButton)="onTogglePrimaryActionTableButton($event)"
            data-test="orderable-fertilisers-table"
            [tableType]="'orderable'"
            [columnsToDisplay]="columnsToDisplay"
          ></app-overview-table>
        </div>
      }

      @if ((nonOrderableFertilisers$ | async)?.length) {
        <div class="non-orderable-products-container">
          <h3>{{ 'fertilisers-overview.table.nonOrderableProductsTitle' | translate }}</h3>
          <app-overview-table
            data-test="non-orderable-fertilisers-table"
            [tableType]="'non-orderable'"
            [columnsToDisplay]="columnsToDisplay"
          ></app-overview-table>
        </div>
      }

      @if ((proprietaryFertilisers$ | async)?.length) {
        <div class="proprietary-fertilizers-container">
          <h3>{{ 'fertilisers-overview.table.proprietaryFertilizers' | translate }}</h3>
          <app-overview-table
            data-test="proprietary-fertilisers-table"
            [tableType]="'proprietary-fertilizer'"
            [columnsToDisplay]="columnsToDisplay"
          ></app-overview-table>
        </div>
      }

      @if (
        (fertiliserOrderplan$ | async)?.length === 0 && (nonOrderableFertilisers$ | async)?.length === 0 && (proprietaryFertilisers$ | async)?.length === 0
      ) {
        <agr-notification-empty
          data-test="fertilisers-overview__empty"
          [isEmpty]="true"
          [emptyTitle]="'empty-title' | translate"
          [emptyDescription]="'empty-description' | translate"
          [emptyImage]="'/assets/images/no-items-3.png'"
          [emptyActionIcon]="'history'"
          [emptyActionText]="'reset-filters' | translate"
          class="spacing--margin-top"
        ></agr-notification-empty>
      }
    </div>
  </agr-page-toolbar>
}
